export const tabStyles = {
  flex: "1",
  _selected: {
    bg: "white",
    color: "#1A202C",
    fontWeight: "500",
  },
  color: "#1A202C",
  borderRadius: "10px",
  py: 3,
  fontSize: "16px",
  transition: "all 0.2s",
};

export const tabPanelStyles = {
  px: 0,
  py: 4,
  h: "100%",
  overflowY: "auto" as const,
  css: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    "scrollbar-width": "none",
  },
};
